import React from 'react';
import styles from './DropdownItem.module.scss';
import cx from 'classnames';
import { useTranslation } from 'react-i18next';

const DropdownItem = ({ filter, handleClick, selectedFilter }) => {
  const { t } = useTranslation();

  return (
    <div
      className={cx(styles.dropdownItem, { [styles.active]: filter.ROLE == selectedFilter.ROLE })}
      onClick={() => handleClick(filter)}
    >
      <p>{t(filter.TEXT)}</p>
    </div>
  );
};

export default DropdownItem;
